import { logAndCaptureException } from '../../../utils/errorTools'

export interface CartState {
  codesCollapsed: boolean
  formDisabled: boolean
  requestsPending: string[]
  summaryVisible: boolean
}

export type TrackRequestIdAction = {
  type: 'requestPending' | 'requestComplete'
  requestId: string
}
export type ToggleCodesAction = { type: 'toggleCodes' }
export type ToggleSummaryAction = { type: 'toggleSummary' }

export type CartStateReduceAction = TrackRequestIdAction | ToggleCodesAction | ToggleSummaryAction

export const reduceCartState = (prevState: CartState, action: CartStateReduceAction): CartState => {
  if (action.type === 'requestPending') {
    // store requestId in requestsPending and disable form
    prevState.requestsPending.push(action.requestId)
    return {
      ...prevState,
      formDisabled: true,
    }
  }

  if (action.type === 'requestComplete') {
    // find index of first pending request matching requestId
    const completedRequestIndex = prevState.requestsPending.findIndex(
      (requestId) => requestId === action.requestId,
    )
    if (completedRequestIndex < 0) {
      logAndCaptureException(
        new Error(`requestId "${action.requestId}" not found in previous state`),
      )
      return prevState
    }

    // remove completed requestId from array of pending requests
    prevState.requestsPending.splice(completedRequestIndex, 1)
    return {
      ...prevState,
      // enable form when all pending requests have completed
      formDisabled: prevState.requestsPending.length > 0,
    }
  }

  if (action.type === 'toggleCodes') {
    return {
      ...prevState,
      codesCollapsed: !prevState.codesCollapsed,
    }
  }

  if (action.type === 'toggleSummary') {
    return {
      ...prevState,
      summaryVisible: !prevState.summaryVisible,
    }
  }

  logAndCaptureException(new Error(`Unexpected reducer action: ${action.type}`))
  return prevState
}
